import React from "react";
import { Link } from "gatsby";
import ButtonBase from "@mui/material/ButtonBase";
import styled from "@emotion/styled";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PortraitRoundedIcon from '@mui/icons-material/PortraitRounded';
import { HiChatBubbleLeftEllipsis } from "react-icons/hi2";
import { breakpoints, forSize } from "../utils/sizeMixins";
import { recordEvent, Events } from "../analytics";

const StyledContactBtn = styled(ButtonBase)`
    justify-self: flex-end;
    width: 80%;
    max-height: 50px;
    ${'' /* border: 2px solid var(--contact-btn-border); */}
    border-radius: 1em;
    background-color: var(--contact-btn-background-color);
    color: var(--ex-primary-text-color);
    cursor: pointer;
    transition: background-color 0.2s ease-in-out, border 0.2s ease-in-out, color 0.2s ease-in-out;
    
    font-size: 1.1em;
    font-weight: 600;
    margin-bottom: 1em;

    ${forSize(breakpoints.tabletLg, 'up')} {
        aspect-ratio: 328 / 130;
    }

    ${forSize(breakpoints.tabletLg, 'down')} {
        aspect-ratio: 6 / 3;

    }

    span {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    a {
        text-decoration: none;
        color: inherit;
        width: 100%;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
`;

const ContactBtn = () => {

    const analyticsCaptureClick = () => {
        recordEvent(Events.CONTACT_BTN_CLICKED);
    }

    return (

        <StyledContactBtn>
            <Link to="/contact-us" draggable={false} onClickCapture={analyticsCaptureClick}>
                <span>
                    {/* <ArrowForwardIcon sx={{ marginTop: 0.5 }} /> */}
                    {/* <PortraitRoundedIcon sx={{ marginRight: 0.5 }} /> */}

                    Contact Us
                    <HiChatBubbleLeftEllipsis style={{ marginLeft: 5, marginTop: 3 }} />
                </span>
            </Link>
        </StyledContactBtn>
    )
}

export default ContactBtn;